export default __webpack_public_path__ + "static/media/Solarwinds MSP.a9d86f39.png";